import axios from 'axios';
import { supabase } from './supabaseClient';

export type AuthLocale = 'en' | 'lt' | 'us';

export const registerUser = async (
  fullName: string,
  email: string,
  password: string,
  clientId: string,
  locale: AuthLocale = 'en',
  actionUrlBase?: string
) => {
  const normalizedEmail = email.trim().toLowerCase();

  const base =
    typeof actionUrlBase === 'string' && actionUrlBase
      ? actionUrlBase
      : typeof window !== 'undefined'
        ? window.location.origin
        : process.env.NEXT_PUBLIC_APP_URL || 'https://www.gadgetfever.eu';

  const redirectTo = locale === 'en' ? base : `${base}?locale=${locale}`;

  const { data, error } = await supabase.auth.signUp({
    email: normalizedEmail,
    password,
    options: {
      data: { full_name: fullName },
      emailRedirectTo: redirectTo,
    },
  });

  if (error) throw error;
  if (!data.user) throw new Error('Sign up failed');

  await axios.post('/api/auth/register', {
    uid: data.user.id,
    fullName,
    email: normalizedEmail,
    clientId,
  });

  await supabase.auth.signOut();
  document.cookie = '__session=; path=/; max-age=0';

  return data.user;
};
